import React, { useEffect, useState, useRef } from "react";
import ChecklistModal from "../../components/standalonefs/ChecklistModal";
import ReferenceModal from "../../components/standalonefs/ReferenceModal";
import DeletePopup from "../../elements/DeletePopup";
import commoncss from "../../css/common.module.css";
import libcss from "../../css/library.module.css";
import "./ConsolFSTable.css"

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import MenuIcon from "../../assets/icons/Menu.png";
import { ReactComponent as DelIcon } from "../../assets/icons/delete_red.svg";
import { ReactComponent as PlusIcon } from "../../assets/icons/plusprimary.svg";
import FormulaIcon from "../../assets/icons/formulaIcon.png";
import linkedIcon from "../../assets/icons/linked.png";
import { ReactComponent as LinkIcon } from "../../assets/icons/Link.svg";
import BoldIcon from "../../assets/icons/BoldIcon.png";

const genObjectId = () => {
  return Array.from({ length: 24 }, () =>
    Math.floor(Math.random() * 16).toString(16)
  ).join("");
};

const isValueColumn = (col) => {
  const fieldLower = String(col.field || "").toLowerCase();
  const labelLower = String(col.label || "").toLowerCase();
  const colLower = fieldLower + " " + labelLower;
  const isAmountOrYear =
    colLower.includes("amount") ||
    colLower.includes("current year") ||
    colLower.includes("previous year") ||
    colLower.includes("currentyear") ||
    colLower.includes("previousyear") ||
    /\bcy\b/.test(colLower) ||
    /\bpy\b/.test(colLower);
  return (
    col.type === "number" ||
    fieldLower.includes("currentyear") ||
    fieldLower.includes("previousyear") ||
    fieldLower.includes("current year") ||
    fieldLower.includes("previous year") ||
    labelLower.includes("current year") ||
    labelLower.includes("previous year") ||
    fieldLower.includes("basecurrentyear") ||
    fieldLower.includes("basepreviousyear") ||
    fieldLower.includes("amount") ||
    fieldLower.includes("value") ||
    fieldLower.includes("total") ||
    fieldLower.includes("balance") ||
    fieldLower.includes("cy") ||
    fieldLower.includes("py")
  );
};

const isHeaderRow = (row) => {
  const lineType = String(row?.lineType || "").toLowerCase();
  const particular = String(row?.particular || "").trim();
  return (
    lineType === "header" ||
    (row?.level === 1 && lineType !== "formula") ||
    /^[A-Z]\.\s+/i.test(particular)
  );
};


const isCyPyColumn = (colOrField) => {
  if (!colOrField) return false;
  const fieldStr = typeof colOrField === "string" ? colOrField : String(colOrField.field || colOrField.label || "");
  const fieldLower = fieldStr.toLowerCase();

  if (
    fieldLower.includes("particular") ||
    fieldLower.includes("description") ||
    fieldLower.includes("name") ||
    fieldLower.includes("note") ||
    fieldLower.includes("reference") ||
    fieldLower.includes("remark")
  ) {
    return false;
  }

  return (
    fieldLower.includes("currentyear") ||
    fieldLower.includes("previousyear") ||
    fieldLower.includes("current year") ||
    fieldLower.includes("previous year") ||
    fieldLower.includes("basecurrentyear") ||
    fieldLower.includes("basepreviousyear") ||
    /\bcy\b/.test(fieldLower) ||
    /\bpy\b/.test(fieldLower)
  );
};

const isPyColumn = (colOrField) => {
  if (!colOrField) return false;
  const fieldStr = typeof colOrField === "string" ? colOrField : String(colOrField.field || colOrField.label || "");
  const fieldLower = fieldStr.toLowerCase();
  return (
    fieldLower.includes("previousyear") ||
    fieldLower.includes("previous year") ||
    fieldLower.includes("basepreviousyear") ||
    /\bpy\b/.test(fieldLower)
  );
};

export default function ConsolFSTable({
  columns: rawColumns = [],
  rows = [],
  onRowsChange = () => {},
  onCellChangeImmediate = () => {},
  brandingClass = "ft-branding",
  emptyMessage = "No data for this category",
  containerWidth = "100%",
  redirectTo = () => {},
  checklistRef = () => {},
  tableTitle = null,
  tableId = null,
  tableLayout = "fixed",
  tableType = "table",
  deletePopulateFS = () => {},
  isNotesTable = false,
  isPrePopulate = false,
  isNotesView = false,
  activeCat = "",
  allowDragAndAdd = false,
  groupedColumns = null,
  onCellLinkClick = () => {},
  linkedCells = {},
  cellFormulas = [],
  onAddRow = null,
}) {
  const columns = React.useMemo(() => {
    return (rawColumns || []).filter((c) => {
      const f = String(c?.field || "").toLowerCase().trim();
      const l = String(c?.label || "").toLowerCase().trim();
      return (
        f !== "isbold" &&
        f !== "formulatype" &&
        l !== "isbold" &&
        l !== "formulatype" &&
        f !== "is_bold" &&
        f !== "formula_type" &&
        f !== "_id" &&
        f !== "linetype"
      );
    });
  }, [rawColumns]);

  const [localRows, setLocalRows] = useState(
    Array.isArray(rows) ? [...rows] : []
  );
  const [editing, setEditing] = useState(null); 
  const inputRef = useRef(null);
  const [showChecklistModal, setShowChecklistModal] = useState(false);
  const [viewReferenceModal, setViewReferenceModal] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [refrenceModalData, setReferenceModalData] = useState(null);
  const [deleteConfirmData, setDeleteConfirmData] = useState(false);
  const isRowBold = (r) => {
    if (!r) return false;
    const b = r.isBold !== undefined ? r.isBold : r.isbold;
    if (typeof b === "boolean") return b;
    if (typeof b === "number") return b === 1;
    if (typeof b === "string") return b.toLowerCase() === "true" || b === "1";
    return false;
  };

  const handleToggleBold = (rIdx) => {
    const row = localRows[rIdx];
    if (!row) return;
    const currentBold = isRowBold(row);
    const updated = [...localRows];
    updated[rIdx] = { ...row, isBold: !currentBold, isbold: !currentBold };
    setLocalRows(updated);
    if (typeof onRowsChange === "function") {
      onRowsChange(updated, tableId);
    }
  };

  const handleDeleteCashflowRow = (rIdx) => {
    const row = localRows[rIdx];
    if (!row) return;
    const updated = localRows.filter((_, idx) => idx !== rIdx);
    setLocalRows(updated);
    if (typeof onRowsChange === "function") {
      onRowsChange(updated, tableId);
    }
  };

  const renderCellLinkIcon = (row, period, rIdx) => {
    if (
      (activeCat === "disclosure" && isPrePopulate) ||
      (activeCat !== "cashflow" && activeCat !== "disclosure") ||
      !period ||
      !isCyPyColumn(period) ||
      row.level === 1 ||
      (row.lineType || "").toLowerCase() === "header"
    ) {
      return null;
    }

    const periodStr = String(period);
    const periodLower = periodStr.toLowerCase();

    const rowParticular = String(row.Particulars || row.particular || row.particulars || row.name || row.description || "").trim().toLowerCase();
    const rowId = String(row._id || row.id || row.rowId || "").toLowerCase();

    const formulasList = Array.isArray(cellFormulas) && cellFormulas.length
      ? cellFormulas
      : Array.isArray(row.cellFormulas)
      ? row.cellFormulas
      : [];

    const cellFormula =
      formulasList.find(
        (f) =>
          String(f.col).toLowerCase() === periodLower &&
          (String(f.row || f.rowID || f.rowId || "").trim().toLowerCase() === rowParticular ||
           (rowId && String(f.row || f.rowID || f.rowId || "").trim().toLowerCase() === rowId))
      ) ||
      (Array.isArray(row.cellFormulas) ? row.cellFormulas : []).find(
        (f) => String(f.col).toLowerCase() === periodLower
      ) ||
      (linkedCells &&
        (linkedCells[`${tableId}-${rIdx}-${periodStr}`] ||
          linkedCells[`${tableId}-${rIdx}-${periodLower}`] ||
          (rowParticular && linkedCells[`${tableId}-${rowParticular}-${periodLower}`])));

    const hasFormula =
      row.type === "formula" ||
      !!row.formula ||
      cellFormula?.type === "formula";

    const hasLink =
      !!row.type ||
      !!cellFormula;

    const isHighlighted = hasFormula || hasLink;
    return (
      <span
        className="consol-cashflow-link-icon"
        onClick={(e) => {
          e.stopPropagation();
          onCellLinkClick(row, periodStr, tableId, isHighlighted);
        }}
        style={{
          display: isHighlighted ? "inline-flex" : undefined,
          background: isHighlighted ? "transparent" : undefined,
          width: "22px",
          height: "22px",
          cursor: "pointer",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        {hasFormula ? (
          <img src={FormulaIcon} style={{ width: 16, height: 16 }} alt="formula" />
        ) : hasLink ? (
          <img src={linkedIcon} style={{ width: 20, height: 10 }} alt="link" />
        ) : (
          <LinkIcon style={{ width: 16, height: 16, color: "#fff" }} />
        )}
      </span>
    );
  };
  
  const [editingHeaderIdx, setEditingHeaderIdx] = useState(null);
  const [editingHeaderVal, setEditingHeaderVal] = useState("");
  const headerInputRef = useRef(null);

  useEffect(() => {
    if (editingHeaderIdx !== null && headerInputRef.current) {
      try {
        headerInputRef.current.focus();
        headerInputRef.current.select?.();
      } catch (e) {}
    }
  }, [editingHeaderIdx]);

  const startEditHeader = (i, currentLabel) => {
    if (activeCat !== "disclosure") return;
    setEditingHeaderIdx(i);
    setEditingHeaderVal(currentLabel || "");
  };

  const commitHeaderEdit = (i, newVal) => {
    setEditingHeaderIdx(null);
    const targetCol = columns[i];
    if (!targetCol) return;
    const oldField = targetCol.field;
    const trimmedVal = (newVal || "").trim();
    if (!trimmedVal || trimmedVal === oldField || trimmedVal === targetCol.label) return;

    const newField = trimmedVal;
    const updated = localRows.map((r) => {
      const newRow = {};
      Object.keys(r).forEach((k) => {
        if (k === oldField) {
          newRow[newField] = r[oldField] !== undefined ? r[oldField] : "";
        } else {
          newRow[k] = r[k];
        }
      });
      return newRow;
    });

    setLocalRows(updated);
    try {
      onRowsChange(updated, tableId);
    } catch (e) {
      console.error("onRowsChange header error", e);
    }
  };

  useEffect(() => {
    setLocalRows(Array.isArray(rows) ? [...rows] : []);
    setEditing(null);
    setEditingHeaderIdx(null);
  }, [rows]);

  useEffect(() => {
    if (editing && inputRef.current) {
      try {
        inputRef.current.focus();
        inputRef.current.select?.();
      } catch (e) {}
    }
  }, [editing]);

  const isRowEditable = (row, col) => {
    if (!row || !col) return false;
    const lineType = (row.lineType || "").toLowerCase();
    if (lineType === "header" || lineType === "formula") return false;
    if (col.type === "checkbox") return false;

    const fieldLower = String(col.field || "").toLowerCase();
    const isParticularCol = fieldLower.includes("particular") || fieldLower.includes("name");

    // In Cashflow, only the particular column is editable on line items
    if (activeCat === "cashflow") {
      if (lineType === "line item" || lineType === "row" || lineType === "" || row.isNewRow) {
        return isParticularCol;
      }
      return false;
    }

    // In Disclosure, all data cells are editable
    if (activeCat === "disclosure") {
      return true;
    }

    // While creating (newly added row): allow editing
    if (row.isNewRow) {
      return true;
    }

    // For already created rows: only allow editing if col.editable is explicitly true
    if (col.editable) {
      return true;
    }

    return false;
  };

  const startEdit = (rowIdx, col) => {
    const row = localRows[rowIdx];
    if (!isRowEditable(row, col)) return;
    setEditing({ rowIdx, field: col.field, col });
  };

  const commitValue = (valueStr) => {
    if (!editing) return;
    const { rowIdx, field, col } = editing;
    const updated = [...localRows];
    let newVal = valueStr;

    if (col.type === "number" || isValueColumn(col)) {
      newVal = valueStr === "" ? null : Number(String(valueStr).replace(/,/g, "").replace(/\(/g, "-").replace(/\)/g, ""));
      if (isNaN(newVal)) newVal = null;
    } else if (col.type === "array") {
      newVal = String(valueStr)
        .split(",")
        .map((v) => v.trim())
        .filter(Boolean);
    }

    const rowBefore = updated[rowIdx];
    const isNew = rowBefore?.isNewRow;

    updated[rowIdx] = { ...rowBefore, [field]: newVal };

    if (isNew) {
      const particularVal = (field === "particular" ? newVal : updated[rowIdx].particular) || "";
      if (typeof onAddRow === "function") {
        setLocalRows(updated);
        setEditing(null);
        onAddRow(rowIdx, {
          particular: particularVal,
          lineType: "line item",
        });
      } else {
        updated[rowIdx] = { ...updated[rowIdx], isNewRow: false };
        setLocalRows(updated);
        setEditing(null);
        try {
          onRowsChange(updated, tableId);
        } catch (e) {
          console.error("onRowsChange error", e);
        }
      }
    } else {
      setLocalRows(updated);
      setEditing(null);
      try {
        onRowsChange(updated, tableId);
      } catch (e) {
        console.error("onRowsChange error", e);
      }
    }
  };

  // Emit single-object immediate change: { _id, key, value }
  const emitImmediateChange = (rowIdx, key, value) => {
    const row = localRows[rowIdx] ?? {};
    if (row.isNewRow) return;
    const id = row._id ?? rowIdx;
    try {
      onCellChangeImmediate({ _id: id, key, value, tableId });
    } catch (e) {
      console.error("onCellChangeImmediate error", e);
    }
  };

  // Handles single-value checkbox option columns (field: "value", optionValue: "Y"/"N"/"NA")
  const toggleSingleValueCheckbox = (rowIdx, col, checked) => {
    if (!col.optionValue) {
      console.warn("[ConsolFSTable] checkbox column missing optionValue", col);
      return;
    }
    const updated = [...localRows];
    const row = { ...updated[rowIdx] };

    if (checked) {
      row[col.field] = col.optionValue;
    } else {
      row[col.field] = null;
    }

    updated[rowIdx] = row;
    setLocalRows(updated);

    // immediate emit single-object diff
    emitImmediateChange(rowIdx, col.field, row[col.field]);

    if (!row.isNewRow) {
      try {
        onRowsChange(updated, tableId);
      } catch (e) {
        console.error("onRowsChange error", e);
      }
    }
  };

  const cancel = () => setEditing(null);

  const droppableId = `consol-fs-rows-${tableId || "default"}`;

  const displayValue = (row, field, col) => {
    if (row.level === 1 && row.lineType !== "formula") {
      const fieldLower = String(field || "").toLowerCase();
      if (fieldLower.includes("currentyear") || fieldLower.includes("previousyear")) {
        return "";
      }
    }
    const v = row[field];
    const type = col?.type;

    if (v == null || v === "") {
      if (row.isNewRow || activeCat === "disclosure") {
        return isValueColumn(col) ? "0" : "Type something...";
      }
      return "";
    }

    if (Array.isArray(v)) return v.join(", ");

    if (type === "number" || isValueColumn(col)) {
      const num = Math.round(Number(v));
      if (isNaN(num)) return String(v);

      if (num < 0) {
        return "(" + Math.abs(num).toLocaleString("en-IN") + ")";
      }
      return num.toLocaleString("en-IN");
    }

    if (type === "checkbox") return "";

    return String(v);
  };

  const isBsPlNotesPrePop = isPrePopulate && (activeCat === "BS notes" || activeCat === "PL notes");

  const totalMinWidthPx = (groupedColumns && groupedColumns.particular && groupedColumns.companies)
  ? (groupedColumns.particular.width || 450) +
    groupedColumns.companies.reduce((sum, c) => {
      const cyW = c.width || 150;
      const pyW = isBsPlNotesPrePop ? ((c.width || 150) + 20) : (c.width || 150);
      return sum + cyW + pyW;
    }, 0) +
    (groupedColumns.references ? (groupedColumns.references.width || 300) : 0)
  : columns.reduce((sum, c) => {
      const w = c?.minWidth ?? c?.width;
      const val = typeof w === "number" ? w : 0;
      return sum + val;
    }, 0);


  const normalizedContainerWidth =
    typeof containerWidth === "number"
      ? `${containerWidth}px`
      : containerWidth || "100%";

  const isSocieTable =
    columns?.some(
      (c) =>
        c?.field?.toLowerCase() === "particular" &&
        c?.width &&
        Number(c?.width) >= 400
    );

  const appliedTableLayout = (isSocieTable || activeCat === "disclosure") ? "auto" : tableLayout;

  const handleChecklistModal = (data) => {
    setModalData([]);
    const modalDataObj = {
      header: data.reference,
      libRef: data.libraryReference,
    };
    setModalData(modalDataObj);
    setShowChecklistModal(true);
  };

  const handleReferenceModal = (data) => {
    setReferenceModalData(data);
    console.log("handleReferenceModal data", data);

    setViewReferenceModal(true);
  };

  const addNewRowAtPosition = (indexPosition) => {
    const targetPos = typeof indexPosition === "number" ? indexPosition : localRows.length;
    const newRowId = genObjectId();
    const newRow = {
      _id: newRowId,
      lineType: "line item",
      isNewRow: true,
    };

    columns.forEach((c) => {
      if (c && c.field) {
        newRow[c.field] = isValueColumn(c) ? 0 : "";
      }
    });

    const updated = [...localRows];
    updated.splice(targetPos, 0, newRow);
    setLocalRows(updated);

    const firstCol = columns.find((c) => c.field === "particular") || columns[0];
    if (firstCol) {
      setTimeout(() => {
        setEditing({ rowIdx: targetPos, field: firstCol.field, col: firstCol });
      }, 50);
    }
  };

  const addNewRow = () => {
    addNewRowAtPosition(localRows.length);
  };

  const isHeaderRow = (row) =>
    (row?.lineType || "").toLowerCase() === "header";

  const mergeReorderedDataRows = (dataRows) => {
    let dataIdx = 0;
    return localRows.map((row) =>
      isHeaderRow(row) ? row : dataRows[dataIdx++]
    );
  };

  const onDragEnd = (result) => {
    if (!result.destination || result.destination.index === result.source.index) return;
    const dataRows = localRows.filter((row) => !isHeaderRow(row));
    const items = Array.from(dataRows);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    const merged = mergeReorderedDataRows(items);
    setLocalRows(merged);
    try {
      onRowsChange(merged, tableId, result.source.index, result.destination.index);
    } catch (e) {
      console.error("onRowsChange error", e);
    }
  };

  const handleDeleteFSTable = () => {
    setDeleteConfirmData(true);
  };
  return (
    <div
      style={{
        width: normalizedContainerWidth,
        //overflowX: "auto",
        marginTop: isPrePopulate ? "0px" : "10px",
      }}
      id={tableId}
    > 
      <div className="ft-table-scroll"  
       style={{
        borderRadius: isNotesTable ? "10px" : "12px",
        border: "1px solid #ccd5d3",
        borderCollapse: "separate",
        overflowX: "auto",    
        overflowY: isPrePopulate || isSocieTable ? (isNotesView ? "visible" : "auto") : undefined,
        maxHeight: isPrePopulate || isSocieTable ? (isNotesView ? "none" : (activeCat === "BS notes" || activeCat === "PL notes" ? "calc(100vh - 95px)" : "calc(100vh - 95px)")) : undefined,
        position: "relative",
       }}>
        <table
          className={`ft-table ${brandingClass} ft-scrTable`}
          style={{
            minWidth: `${totalMinWidthPx}px`,
            borderCollapse: "separate",
            tableLayout: appliedTableLayout,
          }}
        >
          {groupedColumns && groupedColumns.particular && groupedColumns.companies && (
            <colgroup>
              <col style={{ width: `${groupedColumns.particular.width || 450}px`, minWidth: `${groupedColumns.particular.width || 450}px` }} />
              {groupedColumns.companies.map((c, ci) => (
                <React.Fragment key={ci}>
                  <col style={{ width: `${c.width || 150}px`, minWidth: `${c.width || 150}px` }} />
                  <col
                    style={{
                      width: isBsPlNotesPrePop ? `${(c.width || 150) + 20}px` : `${c.width || 150}px`,
                      minWidth: isBsPlNotesPrePop ? `${(c.width || 150) + 20}px` : `${c.width || 150}px`,
                    }}
                  />
                </React.Fragment>
              ))}
              {groupedColumns.references && (
                <col style={{ width: `${groupedColumns.references.width || 300}px`, minWidth: `${groupedColumns.references.width || 300}px` }} />
              )}
            </colgroup>
          )}
          <thead style={isPrePopulate || isSocieTable ? { position: "sticky", top: 0, zIndex: 150, backgroundColor: "#fff" } : undefined}>
  {(tableTitle || (activeCat === "disclosure" && tableId && deletePopulateFS) || tableType === "link register") && (
    <tr className="ft-table-title-row" style={{ backgroundColor: "#ffffff", background: "#ffffff", ...(isPrePopulate || isSocieTable ? { position: "sticky", top: 0, zIndex: 151 } : {}) }}>
      <th
        colSpan={
          (groupedColumns && groupedColumns.companies)
            ? 1 + groupedColumns.companies.length * 2 + (groupedColumns.references ? 1 : 0)
            : columns.length
        }
        style={{
          ...(isPrePopulate || isSocieTable ? { position: "sticky", top: 0, left: 0, zIndex: 151, background: "#ffffff", backgroundColor: "#ffffff" } : { background: "#ffffff", backgroundColor: "#ffffff" }),
          borderBottom: "1px solid #ccd5d3",
          textAlign: "left",
          backgroundColor: "#ffffff",
          position: (isPrePopulate || isSocieTable) ? "sticky" : "relative",
        }}
      >
        <div className="ft-table-title" style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <span
            style={{
              position: "sticky",
              left: "13px",
              display: "inline-flex",
              alignItems: "center",
              zIndex: 10,
              whiteSpace: "nowrap",
            }}
          >
            {tableTitle || ""}
          </span>
          {(tableType === "link register" || (activeCat === "disclosure" && tableId && deletePopulateFS)) && (
            <div style={{ display: "flex", gap: "10px", alignItems: "center", position: "sticky", right: "10px" }}>
              <DelIcon 
                style={{ cursor: "pointer", width: 16, height: 16 }} 
                onClick={handleDeleteFSTable} 
                title="Delete table"
              />
            </div>
          )}
        </div>
      </th>
    </tr>
  )}

  {(groupedColumns && groupedColumns.particular && groupedColumns.companies) ? (
    <>
      <tr>
        <th
          rowSpan={isPrePopulate ? 1 : 2}
          style={{
            width: `${groupedColumns.particular.width}px`,
            minWidth: `${groupedColumns.particular.width}px`,
            textAlign: "left",
            verticalAlign: "middle",
            paddingLeft: isPrePopulate ? "24px" : undefined,
            borderRight: "1px solid #ccd5d3",
            borderBottom: "1px solid #ccd5d3",
            position: "sticky",
            top: tableTitle ? 32 : 0,
            left: (isSocieTable || activeCat === "BS notes" || activeCat === "PL notes") ? 0 : undefined,
            zIndex: (isSocieTable || activeCat === "BS notes" || activeCat === "PL notes") ? 155 : 105,
            backgroundColor: "#eef6ef",
          }}
        >
          Particular
        </th>
        {groupedColumns.companies.map((company, i) => (
          <th
            key={`grp-${i}`}
            colSpan={2}
            style={{
              textAlign: "center",
              borderRight: "1px solid #ccd5d3",
              borderBottom: "1px solid #ccd5d3",
              position: "sticky",
              top: tableTitle ? 32 : 0,
              zIndex: 105,
              backgroundColor: "#eef6ef",
              fontWeight: 600,
              ...(isPrePopulate && (activeCat === "BS notes" || activeCat === "PL notes") && {
                paddingLeft: "50px",
                paddingRight: "0px",
              }),
            }}
          >
            {company.title}
          </th>
        ))}
        {groupedColumns.references && (
          <th
            rowSpan={isPrePopulate ? 1 : 2}
            style={{
              width: `${groupedColumns.references.width}px`,
              minWidth: `${groupedColumns.references.width}px`,
              textAlign: "left",
              verticalAlign: "middle",
              borderBottom: "1px solid #ccd5d3",
              position: "sticky",
              top: tableTitle ? 32 : 0,
              zIndex: 105,
              backgroundColor: "#eef6ef",
            }}
          >
            References
          </th>
        )}
      </tr>
      <tr>
        {isPrePopulate && (
          <th
            style={{
              width: `${groupedColumns.particular.width}px`,
              minWidth: `${groupedColumns.particular.width}px`,
              borderRight: "1px solid #ccd5d3",
              borderBottom: "1px solid #ccd5d3",
              position: "sticky",
              top: tableTitle ? 64 : 32,
              left: (isSocieTable || activeCat === "BS notes" || activeCat === "PL notes") ? 0 : undefined,
              zIndex: (isSocieTable || activeCat === "BS notes" || activeCat === "PL notes") ? 155 : 105,
              backgroundColor: "#eef6ef",
            }}
          ></th>
        )}
        {groupedColumns.companies.map((company, i) => {
          const isBsPlNotesPrePop = isPrePopulate && (activeCat === "BS notes" || activeCat === "PL notes");
          return (
          <React.Fragment key={`sub-${i}`}>
            <th
              style={{
                width: `${company.width}px`,
                minWidth: `${company.width}px`,
                textAlign: isBsPlNotesPrePop ? "right" : (activeCat === "BS notes" || activeCat === "PL notes") ? "center" : "right",
                paddingRight: isBsPlNotesPrePop ? "35px" : undefined,
                borderRight: "1px solid #ccd5d3",
                borderBottom: "1px solid #ccd5d3",
                position: "sticky",
                top: tableTitle ? 64 : 32,
                zIndex: 105,
                backgroundColor: "#eef6ef",
                fontWeight: 700,
                fontSize: "12px",
              }}
            >
              {isBsPlNotesPrePop ? "CY" : (activeCat === "BS notes" || activeCat === "PL notes") ? <div style={{ display: "inline-block", width: "100px", textAlign: "center", paddingLeft: "10px" }}>CY</div> : "CY"}
            </th>
            <th
              style={{
                width: isBsPlNotesPrePop ? `${(company.width || 150) + 20}px` : `${company.width}px`,
                minWidth: isBsPlNotesPrePop ? `${(company.width || 150) + 20}px` : `${company.width}px`,
                textAlign: isBsPlNotesPrePop ? "right" : (activeCat === "BS notes" || activeCat === "PL notes") ? "center" : "right",
                paddingRight: isBsPlNotesPrePop ? "55px" : undefined,
                borderRight: "none",
                borderBottom: "1px solid #ccd5d3",
                position: "sticky",
                top: tableTitle ? 64 : 32,
                zIndex: 105,
                backgroundColor: "#eef6ef",
                fontWeight: 700,
                fontSize: "12px",
              }}
            >
              {isBsPlNotesPrePop ? "PY" : (activeCat === "BS notes" || activeCat === "PL notes") ? <div style={{ display: "inline-block", width: "100px", textAlign: "center", paddingLeft: "10px" }}>PY</div> : "PY"}
            </th>
          </React.Fragment>
        );})}
        {isPrePopulate && groupedColumns.references && (
          <th
            style={{
              width: `${groupedColumns.references.width}px`,
              minWidth: `${groupedColumns.references.width}px`,
              borderBottom: "1px solid #ccd5d3",
              position: "sticky",
              top: tableTitle ? 64 : 32,
              zIndex: 105,
              backgroundColor: "#eef6ef",
            }}
          ></th>
        )}
      </tr>
    </>
  ) : (
    <tr style={{ backgroundColor: "#eef6ef" }}>
      {columns.map((c, i) => {
        const colWidth = c.width || (c.field === "baseCurrentYear" ? 160 : undefined);
        const widthStyle = colWidth ? (typeof colWidth === "number" ? `${colWidth}px` : colWidth) : undefined;
        const isSocie = activeCat === "socie" || tableType === "socie" || isSocieTable;
        const isDisclosureCyPy = !isPrePopulate && activeCat === "disclosure" && isCyPyColumn(c);
        const titleOffset = tableTitle ? 32 : 0;

        return (
          <th
            key={i}
            style={{
              width: widthStyle,
              minWidth: widthStyle,
              maxWidth: widthStyle,
              textAlign: c.align || "left",
              backgroundColor: "#eef6ef",
              paddingLeft: i === 0 && allowDragAndAdd ? "28px" : undefined,
              ...((isPrePopulate || isSocieTable) && {
                verticalAlign: "middle",
                borderRight: isSocie ? "none" : "1px solid #ccd5d3",
                borderBottom: "1px solid #ccd5d3",
                position: "sticky",
                top: titleOffset,
                zIndex: i === 0 && isSocieTable ? 155 : 105,
                backgroundColor: "#eef6ef",
                ...(i === 0 && isSocieTable && { left: 0 })
              })
            }}
            className={
              c.align === "right"
                ? "ft-align-right"
                : c.align === "center"
                ? "ft-align-center"
                : "ft-align-left"
            }
          >
            {activeCat === "disclosure" && editingHeaderIdx === i ? (
              <input
                ref={headerInputRef}
                className="ft-edit-input"
                style={{
                  fontSize: "12px",
                  fontWeight: 600,
                  color: "#205a46",
                  background: "#fff",
                  border: "1px solid #3AB67D",
                  borderRadius: "4px",
                  padding: "4px 8px",
                  width: "100%",
                  textAlign: c.align || "left",
                }}
                value={editingHeaderVal}
                placeholder="Column Name"
                onChange={(e) => setEditingHeaderVal(e.target.value)}
                onBlur={() => commitHeaderEdit(i, editingHeaderVal)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") commitHeaderEdit(i, editingHeaderVal);
                  if (e.key === "Escape") setEditingHeaderIdx(null);
                }}
              />
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: c.align === "right" ? "flex-end" : c.align === "center" ? "center" : "flex-start",
                  textAlign: c.align || "left",
                  width: "100%",
                  whiteSpace: isSocie ? "normal" : "nowrap",
                  wordBreak: isSocie ? "break-word" : undefined,
                  lineHeight: isSocie ? "1.25" : undefined,
                  padding: isSocie ? "4px 0" : undefined,
                  paddingRight: isDisclosureCyPy ? "30px" : undefined,
                  cursor: activeCat === "disclosure" ? "pointer" : "default",
                }}
                onClick={() => {
                  if (activeCat === "disclosure") {
                    startEditHeader(i, c.label);
                  }
                }}
                title={activeCat === "disclosure" ? "Click to edit column name" : undefined}
              >
                {c.label || <span style={{ color: "#aaa", fontStyle: "italic" }}>Column Name</span>}
              </div>
            )}
          </th>
        );
      })}
    </tr>
  )}
</thead>


          {allowDragAndAdd ? (
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId={droppableId} type="ROW">
                {(provided) => (
                  <tbody ref={provided.innerRef} {...provided.droppableProps}>
                    {!localRows || localRows.length === 0 ? (
                      <tr>
                        <td
                          colSpan={columns.length}
                          style={{ textAlign: "center", padding: 20 }}
                        >
                          {emptyMessage}
                        </td>
                      </tr>
                    ) : (
                      (() => {
                        let dragIndex = 0;
                        return localRows.map((row, rIdx) => {
                        const rowKey = row._id ?? rIdx;
                        const isNextHeader = rIdx < localRows.length - 1 && isHeaderRow(localRows[rIdx + 1]);
                        const isLastRow = rIdx === localRows.length - 1;
                        const isSectionEnd = activeCat === "cashflow" && (isNextHeader || isLastRow);

                        const renderSectionAddButton = () => {
                          if (!isSectionEnd) return null;
                          return (
                            <tr
                              key={`add-row-sec-${rIdx}`}
                              className="ft-add-line-item-row"
                              style={{
                                backgroundColor: "#ffffff",
                                background: "#ffffff",
                                border: "none",
                              }}
                            >
                              <td
                                colSpan={columns.length}
                                style={{
                                  border: "none",
                                  borderTop: "none",
                                  borderBottom: "none",
                                  padding: "6px 0px 6px 15px",
                                  backgroundColor: "#ffffff",
                                  background: "#ffffff",
                                }}
                              >
                                <button
                                  type="button"
                                  onClick={() => addNewRowAtPosition(rIdx + 1)}
                                  style={{
                                    background: "#ffffff",
                                    backgroundColor: "#ffffff",
                                    border: "none",
                                    color: "#205a46",
                                    cursor: "pointer",
                                    fontWeight: "500",
                                    padding: "6px 12px 6px 0px",
                                    fontSize: "13px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                  }}
                                >
                                  <PlusIcon style={{ width: 14, height: 14 }} /> Add Line Item
                                </button>
                              </td>
                            </tr>
                          );
                        };

                        if (isHeaderRow(row)) {
                          return (
                            <React.Fragment key={`hdr-grp-${rowKey}`}>
                              <tr key={rowKey}>
                                <td
                                  colSpan={columns.length}
                                  style={{
                                    background: "#eaeeed",
                                    borderCollapse: "separate",
                                    color: "#33584e",
                                    fontWeight: 600,
                                    textAlign: "left",
                                    borderTopLeftRadius: tableTitle ? 0 : undefined,
                                    borderTopRightRadius: tableTitle ? 0 : undefined,
                                  }}
                                >
                                  {row.particular}
                                </td>
                              </tr>
                              {renderSectionAddButton()}
                            </React.Fragment>
                          );
                        }

                        const normalize = (str) =>
                          String(str || "").replace(/[^a-z0-9]/gi, "").toLowerCase();
                        const rowId = normalize(row.particular);
                        const draggableId = `${droppableId}-${rowKey}`;
                        const currentDragIndex = dragIndex++;

                        return (
                          <React.Fragment key={`row-wrap-${rowKey}`}>
                            <Draggable
                              key={rowKey}
                              draggableId={draggableId}
                              index={currentDragIndex}
                            >
  {(dragProvided, snapshot) => {
    const isDragging = snapshot?.isDragging;
    const draggingStyle = isDragging ? {
      backgroundColor: "#fff",
      boxShadow: "0px 10px 20px rgba(0,0,0,0.15)",
      zIndex: 9999,
      display: "table"
    } : {};

    return (
    <tr
      ref={dragProvided.innerRef}
      {...dragProvided.draggableProps}
      id={rowId}
      style={{
        fontWeight: isRowBold(row) ? 700 : undefined,
        backgroundColor: row.level === 1 ? "#eaeeed" : undefined,
        ...dragProvided.draggableProps.style,
        ...draggingStyle
      }}
    >
      {(groupedColumns && groupedColumns.particular && groupedColumns.companies) ? (
        <>
          <td
            style={{
              position: (isSocieTable || activeCat === "BS notes" || activeCat === "PL notes") ? "sticky" : "static",
              left: (isSocieTable || activeCat === "BS notes" || activeCat === "PL notes") ? 0 : undefined,
              zIndex: (isSocieTable || activeCat === "BS notes" || activeCat === "PL notes") ? 100 : undefined,
              backgroundColor: isDragging ? "#fff" : (row.level === 1 ? "#eaeeed" : ((isSocieTable || activeCat === "BS notes" || activeCat === "PL notes") ? "#fff" : undefined)),
              width: `${groupedColumns.particular.width}px`,
              minWidth: `${groupedColumns.particular.width}px`,
              textAlign: "left",
              paddingLeft: isPrePopulate ? "24px" : undefined,
              borderRight: "none",
              borderTop: isDragging ? "1px solid #3AB67D" : undefined,
              borderBottom: isDragging ? "1px solid #3AB67D" : undefined,
              borderLeft: isDragging ? "1px solid #3AB67D" : undefined,
            }}
          >
            {row.particular ?? ""}
          </td>

          {groupedColumns.companies.map((company, ci) => {
            const isLastCompany = ci === groupedColumns.companies.length - 1;
            const isLastCol = isLastCompany && !groupedColumns.references;
            const isBsPlNotesPrePop = isPrePopulate && (activeCat === "BS notes" || activeCat === "PL notes");
            return (
            <React.Fragment key={`cell-${ci}`}>
              <td
                style={{
                  position: "relative",
                  width: `${company.width}px`,
                  minWidth: `${company.width}px`,
                  textAlign: isBsPlNotesPrePop ? "right" : (activeCat === "BS notes" || activeCat === "PL notes") ? "center" : "right",
                  borderRight: "1px solid #ccd5d3",
                  backgroundColor: isDragging ? "#fff" : undefined,
                  borderTop: isDragging ? "1px solid #3AB67D" : undefined,
                  borderBottom: isDragging ? "1px solid #3AB67D" : undefined,
                  paddingRight: isBsPlNotesPrePop ? "35px" : (activeCat === "cashflow" ? "35px" : undefined),
                }}
              >
                {(() => {
                  if (row.level === 1 && row.lineType !== "formula") return "";
                  const v = row[company.cyField];
                  if (v == null || v === "") return "";
                  const num = Number(v);
                  if (isNaN(num)) return String(v);
                  const formatted = num < 0
                    ? "(" + Math.abs(num).toLocaleString("en-IN") + ")"
                    : num.toLocaleString("en-IN");
                  if (!isBsPlNotesPrePop && (activeCat === "BS notes" || activeCat === "PL notes")) {
                    return <div style={{ display: "inline-block", width: "100px", textAlign: "right", paddingRight: "30px" }}>{formatted}</div>;
                  }
                  return formatted;
                })()}
                {renderCellLinkIcon(row, company.cyField || "currentYear", rIdx)}
              </td>

              <td
                style={{
                  position: "relative",
                  width: isBsPlNotesPrePop ? `${(company.width || 150) + 20}px` : `${company.width}px`,
                  minWidth: isBsPlNotesPrePop ? `${(company.width || 150) + 20}px` : `${company.width}px`,
                  textAlign: isBsPlNotesPrePop ? "right" : (activeCat === "BS notes" || activeCat === "PL notes") ? "center" : "right",
                  borderRight: isDragging && isLastCol ? "1px solid #3AB67D" : "none",
                  backgroundColor: isDragging ? "#fff" : undefined,
                  borderTop: isDragging ? "1px solid #3AB67D" : undefined,
                  borderBottom: isDragging ? "1px solid #3AB67D" : undefined,
                  paddingRight: isBsPlNotesPrePop ? "55px" : (activeCat === "cashflow" ? "35px" : undefined),
                }}
              >
                {(() => {
                  if (row.level === 1 && row.lineType !== "formula") return "";
                  const v = row[company.pyField];
                  if (v == null || v === "") return "";
                  const num = Number(v);
                  if (isNaN(num)) return String(v);
                  const formatted = num < 0
                    ? "(" + Math.abs(num).toLocaleString("en-IN") + ")"
                    : num.toLocaleString("en-IN");
                  if (!isBsPlNotesPrePop && (activeCat === "BS notes" || activeCat === "PL notes")) {
                    return <div style={{ display: "inline-block", width: "100px", textAlign: "right", paddingRight: "30px" }}>{formatted}</div>;
                  }
                  return formatted;
                })()}
                {renderCellLinkIcon(row, company.pyField || "previousYear", rIdx)}
              </td>
            </React.Fragment>
          );})}

          {groupedColumns.references && (
            <td
              style={{
                width: `${groupedColumns.references.width}px`,
                minWidth: `${groupedColumns.references.width}px`,
                textAlign: "left",
                backgroundColor: isDragging ? "#fff" : undefined,
                borderTop: isDragging ? "1px solid #3AB67D" : undefined,
                borderBottom: isDragging ? "1px solid #3AB67D" : undefined,
                borderRight: isDragging ? "1px solid #3AB67D" : undefined,
              }}
            >
              {Array.isArray(row.references)
                ? row.references.map((item, index) => (
                    <span key={index}>
                      <span
                        onClick={() => handleReferenceModal(item)}
                        style={{
                          cursor: "pointer",
                          marginRight: "8px",
                          textDecoration: "underline",
                        }}
                      >
                        {item}
                      </span>
                      {index < row.references.length - 1 && ", "}
                    </span>
                  ))
                : row.references ?? ""}
            </td>
          )}
        </>
      ) : (
        <>
          {columns.map((col, cIdx) => {
            const isEditing =
              editing &&
              editing.rowIdx === rIdx &&
              editing.field === col.field;

            const inputAlignClass =
              col.field === "notes"
                ? "ft-input-center"
                : col.align === "right"
                ? "ft-input-right"
                : col.align === "center"
                ? "ft-input-center"
                : "ft-input-left";

            const cellText = displayValue(row, col.field, col);

            const isEmptyPlaceholder =
              (row.isNewRow || activeCat === "disclosure") &&
              (row[col.field] == null || String(row[col.field]).trim() === "");

            const handleCellClick = () => {
              if (col.type === "checkbox") return;
              startEdit(rIdx, col);
            };

            const colWidth =
              col.width ||
              (col.field === "baseCurrentYear" ? 160 : undefined);

            const widthStyle = colWidth
              ? typeof colWidth === "number"
                ? `${colWidth}px`
                : colWidth
              : undefined;

            const totalColumnsCount = columns.length;
            const isFirstCol = cIdx === 0;
            const isLastCol = cIdx === totalColumnsCount - 1;

            return (
              <td
                key={cIdx}
                style={{
                  position: isFirstCol && isSocieTable ? "sticky" : "relative",
                  left: isFirstCol && isSocieTable ? 0 : undefined,
                  zIndex: isFirstCol && isSocieTable ? 100 : undefined,
                  backgroundColor: isDragging ? "#fff" : (row.level === 1 ? "#eaeeed" : (isFirstCol && isSocieTable ? "#fff" : undefined)),
                  width: widthStyle,
                  minWidth: widthStyle,
                  maxWidth: widthStyle,
                  paddingLeft:
                    isFirstCol && allowDragAndAdd ? "28px" : undefined,
                  borderTop: isDragging ? "1px solid #3AB67D" : undefined,
                  borderBottom: isDragging ? "1px solid #3AB67D" : undefined,
                  borderLeft: (isDragging && isFirstCol) ? "1px solid #3AB67D" : undefined,
                  borderRight: (isDragging && isLastCol && !(allowDragAndAdd || activeCat === "cashflow")) ? "1px solid #3AB67D" : undefined,
                }}
                className={`${
                  col.align === "right"
                    ? "ft-align-right"
                    : col.align === "center"
                    ? "ft-align-center"
                    : "ft-align-left"
                } ${isEditing ? "ft-editing" : ""}`}
                onClick={handleCellClick}
                onDoubleClick={handleCellClick}
              >
                {cIdx === 0 && allowDragAndAdd && (
                  <div
                    {...dragProvided.dragHandleProps}
                    className="ft-row-drag-handle"
                    style={{
                      position: "absolute",
                      left: "8px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "14px",
                      height: "20px",
                    }}
                    title="Drag to reorder"
                  >
                    <img
                      src={MenuIcon}
                      alt="drag"
                      style={{ width: 9, height: 13 }}
                    />
                  </div>
                )}

                {col.type === "popup" && (
                  <div style={{ display: "flex", alignItems: "center", justifyContent: col.align === "right" ? "flex-end" : col.align === "center" ? "center" : "flex-start", textAlign: col.align === "right" ? "right" : col.align === "center" ? "center" : "left", width: "100%" }}>
                    <span className={commoncss.clickable} onClick={() => { handleChecklistModal(row); }}>{row[col.field]}</span>
                  </div>
                )}
                {col.type === "checklistref" && (
                  <div style={{ display: "flex", alignItems: "center", justifyContent: col.align === "right" ? "flex-end" : col.align === "center" ? "center" : "flex-start", textAlign: col.align === "right" ? "right" : col.align === "center" ? "center" : "left", width: "100%" }}>
                    {Array.isArray(row[col.field]) ? row[col.field].map((item, index) => (
                      <span key={index}><span onClick={() => { handleReferenceModal(item); }} style={{ cursor: "pointer", marginRight: "8px", textDecoration: "underline" }}>{item}</span>{index < row[col.field].length - 1 && ", "}</span>
                    )) : row[col.field] ?? ""}
                  </div>
                )}
                {col.type === "redirect" && (
                  <div style={{ display: "flex", alignItems: "center", justifyContent: col.align === "right" ? "flex-end" : col.align === "center" ? "center" : "flex-start", textAlign: col.align === "right" ? "right" : col.align === "center" ? "center" : "left", width: "100%" }}>
                    {row[col.field] ? (
                      <span style={{ color: "#205a46", textDecoration: "underline", cursor: "pointer", fontWeight: 600 }} onClick={() => { redirectTo(row[col.field], row); }}>{row[col.field]}</span>
                    ) : (
                      <span style={{ color: "#ccc" }}>{row.level === 1 ? "" : "–"}</span>
                    )}
                  </div>
                )}
                {col.type === "checkbox" ? (
                  <div style={{ display: "flex", alignItems: "center", justifyContent: col.align === "right" ? "flex-end" : col.align === "center" ? "center" : "flex-start", width: "100%" }}>
                    <input name={`chk_${rowKey}_${col.field}_${col.optionValue}`} className="ft-checkbox" type="checkbox" checked={row[col.field] === col.optionValue} onChange={(e) => { const checked = e.target.checked; toggleSingleValueCheckbox(rIdx, col, checked); }} onClick={(e) => e.stopPropagation()} aria-label={`${col.label} checkbox row ${rIdx}`} />
                  </div>
                ) : (
                  <>
                    {col.type !== "redirect" && col.type !== "popup" && col.type !== "checklistref" && (
                      (() => {
                        const isCyPy = isCyPyColumn(col.field) && (activeCat === "cashflow" || (activeCat === "disclosure" && !isPrePopulate));
                        return isCyPy ? (
                          <div
                            style={{
                              visibility: isEditing ? "hidden" : "visible",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-end",
                              textAlign: "right",
                              width: "100%",
                            }}
                          >
                            <span
                              style={{
                                flex: 1,
                                textAlign: "right",
                                color: isEmptyPlaceholder ? "#aaa" : col.field === "notes" ? "#205a46" : "inherit",
                                fontStyle: isEmptyPlaceholder ? "normal" : "normal",
                                fontWeight: (col.field === "notes" || isRowBold(row)) ? 700 : "inherit",
                                textDecoration: col.field === "notes" && !isEmptyPlaceholder ? "underline" : "none",
                              }}
                            >
                              {cellText}
                            </span>
                            <div
                              style={{
                                width: "26px",
                                minWidth: "26px",
                                height: "22px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: 0,
                                marginLeft: "4px",
                              }}
                            >
                              {renderCellLinkIcon(row, col.field, rIdx)}
                            </div>
                          </div>
                        ) : (
                          <div
                            style={{
                              visibility: isEditing ? "hidden" : "visible",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: col.align === "right" ? "flex-end" : col.align === "center" ? "center" : "flex-start",
                              textAlign: col.align || "left",
                              width: "100%",
                              gap: "6px",
                            }}
                          >
                            <span
                              style={{
                                color: isEmptyPlaceholder ? "#aaa" : col.field === "notes" ? "#205a46" : "inherit",
                                fontStyle: isEmptyPlaceholder ? "normal" : "normal",
                                fontWeight: (col.field === "notes" || isRowBold(row)) ? 700 : "inherit",
                                textDecoration: col.field === "notes" && !isEmptyPlaceholder ? "underline" : "none",
                              }}
                            >
                              {cellText}
                            </span>
                            {renderCellLinkIcon(row, col.field, rIdx)}
                          </div>
                        );
                      })()
                    )}
                    {isEditing && col.type !== "redirect" && col.type !== "popup" && col.type !== "checklistref" && (
                      <input ref={inputRef} className={`ft-edit-input ${inputAlignClass} ${(cIdx === columns.length - 1 && (allowDragAndAdd || activeCat === "cashflow")) ? "ft-edit-input-last-cell" : ""}`} type={col.type === "number" ? "number" : "text"} defaultValue={col.type === "array" && Array.isArray(row[col.field]) ? row[col.field].join(", ") : row[col.field] ?? ""} placeholder={row.isNewRow || activeCat === "disclosure" ? (isValueColumn(col) ? "0" : "Type something...") : (col.placeholder ?? "")} onBlur={(e) => commitValue(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") commitValue(e.target.value); if (e.key === "Escape") cancel(); }} onKeyUp={(e) => { const raw = e.target.value; let outgoing = raw; if (col.type === "number") { const n = raw === "" ? null : Number(raw); outgoing = isNaN(n) ? null : n; } else if (col.type === "array") { outgoing = String(raw).split(",").map((v) => v.trim()).filter(Boolean); } const updated = [...localRows]; updated[rIdx] = { ...updated[rIdx], [col.field]: outgoing }; setLocalRows(updated); emitImmediateChange(rIdx, col.field, outgoing); }} />
                    )}
                  </>
                )}

                {/* Action icons - last cell only */}
                {cIdx === columns.length - 1 && (allowDragAndAdd || activeCat === "cashflow") && (
                  <>
                    <div
                      className={`ft-row-bold-icon ${isRowBold(row) ? "active" : ""}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleToggleBold(rIdx);
                      }}
                      title={isRowBold(row) ? "Remove Bold" : "Make Bold"}
                    >
                      <img src={BoldIcon} alt="Bold" style={{ width: 14, height: 14 }} />
                    </div>

                    {row.lineType !== "header" && (
                      <div
                        className="ft-row-delete-icon"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteCashflowRow(rIdx);
                        }}
                        title="Delete row"
                      >
                        <DelIcon style={{ width: 16, height: 16 }} />
                      </div>
                    )}
                  </>
                )}
              </td>
            );
          })}
        </>
      )}
    </tr>
  );}}
</Draggable>
{renderSectionAddButton()}
</React.Fragment>
                        );
                      });
                      })()
                    )}
                    {provided.placeholder}
                  </tbody>
                )}
              </Droppable>
            </DragDropContext>
          ) : (
          <tbody>
            {!localRows || localRows.length === 0 ? (
              <tr>
                <td
                  colSpan={columns.length}
                  style={{ textAlign: "center", padding: 20 }}
                >
                  {emptyMessage}
                </td>
              </tr>
            ) : (
              localRows.map((row, rIdx) => {
                const rowKey = row._id ?? rIdx;

                if ((row.lineType || "").toLowerCase() === "header") {
                  return (
                    <tr key={rowKey}>
                      <td
                        colSpan={columns.length}
                        style={{
                          background: "#eaeeed",
                          borderCollapse: "separate",
                          color: "#33584e",
                          fontWeight: 600,
                          textAlign: "left",
                          borderTopLeftRadius: tableTitle ? 0 : undefined,
                          borderTopRightRadius: tableTitle ? 0 : undefined,
                        }}
                      >
                        {row.particular}
                      </td>
                    </tr>
                  );
                }

                const normalize = (str) => String(str || "").replace(/[^a-z0-9]/gi, "").toLowerCase();
                const rowId = normalize(row.particular);

                return (
  <tr key={rowKey} id={rowId} style={{ fontWeight: isRowBold(row) ? 700 : undefined, backgroundColor: row.level === 1 ? "#eaeeed" : undefined }}>
    {(groupedColumns && groupedColumns.particular && groupedColumns.companies) ? (
      <>
        {/* Particular cell */}
        <td style={{
          position: (isSocieTable || activeCat === "BS notes" || activeCat === "PL notes") ? "sticky" : "static",
          left: (isSocieTable || activeCat === "BS notes" || activeCat === "PL notes") ? 0 : undefined,
          zIndex: (isSocieTable || activeCat === "BS notes" || activeCat === "PL notes") ? 100 : undefined,
          backgroundColor: row.level === 1 ? "#eaeeed" : ((isSocieTable || activeCat === "BS notes" || activeCat === "PL notes") ? "#fff" : undefined),
          width: `${groupedColumns.particular.width}px`,
          minWidth: `${groupedColumns.particular.width}px`,
          textAlign: "left",
          borderRight: "none",
        }}>
          {row.particular ?? ""}
        </td>
        {/* CY | PY cells per company */}
        {groupedColumns.companies.map((company, ci) => {
          const isBsPlNotesPrePop = isPrePopulate && (activeCat === "BS notes" || activeCat === "PL notes");
          return (
          <React.Fragment key={`cell-${ci}`}>
            <td style={{
              position: "relative",
              width: `${company.width}px`,
              minWidth: `${company.width}px`,
              textAlign: isBsPlNotesPrePop ? "right" : (activeCat === "BS notes" || activeCat === "PL notes") ? "center" : "right",
              borderRight: "1px solid #ccd5d3",
              paddingRight: isBsPlNotesPrePop ? "35px" : (activeCat === "cashflow" ? "35px" : undefined),
            }}>
              {(() => {
                if (row.level === 1 && row.lineType !== "formula") return "";
                const v = row[company.cyField];
                if (v == null || v === "") return "";
                const num = Number(v);
                if (isNaN(num)) return String(v);
                const formatted = num < 0 ? "(" + Math.abs(num).toLocaleString("en-IN") + ")" : num.toLocaleString("en-IN");
                if (!isBsPlNotesPrePop && (activeCat === "BS notes" || activeCat === "PL notes")) {
                  return <div style={{ display: "inline-block", width: "100px", textAlign: "right", paddingRight: "30px" }}>{formatted}</div>;
                }
                return formatted;
              })()}
              {renderCellLinkIcon(row, company.cyField || "currentYear", rIdx)}
            </td>
            <td style={{
              position: "relative",
              width: isBsPlNotesPrePop ? `${(company.width || 150) + 20}px` : `${company.width}px`,
              minWidth: isBsPlNotesPrePop ? `${(company.width || 150) + 20}px` : `${company.width}px`,
              textAlign: isBsPlNotesPrePop ? "right" : (activeCat === "BS notes" || activeCat === "PL notes") ? "center" : "right",
              borderRight: "none",
              paddingRight: isBsPlNotesPrePop ? "55px" : (activeCat === "cashflow" ? "35px" : undefined),
            }}>
              {(() => {
                if (row.level === 1 && row.lineType !== "formula") return "";
                const v = row[company.pyField];
                if (v == null || v === "") return "";
                const num = Number(v);
                if (isNaN(num)) return String(v);
                const formatted = num < 0 ? "(" + Math.abs(num).toLocaleString("en-IN") + ")" : num.toLocaleString("en-IN");
                if (!isBsPlNotesPrePop && (activeCat === "BS notes" || activeCat === "PL notes")) {
                  return <div style={{ display: "inline-block", width: "100px", textAlign: "right", paddingRight: "30px" }}>{formatted}</div>;
                }
                return formatted;
              })()}
              {renderCellLinkIcon(row, company.pyField || "previousYear", rIdx)}
            </td>
          </React.Fragment>
        );})}
        {/* References cell */}
        {groupedColumns.references && (
          <td style={{
            width: `${groupedColumns.references.width}px`,
            minWidth: `${groupedColumns.references.width}px`,
            textAlign: "left",
          }}>
            {Array.isArray(row.references)
              ? row.references.map((item, index) => (
                  <span key={index}>
                    <span
                      onClick={() => { handleReferenceModal(item); }}
                      style={{ cursor: "pointer", marginRight: "8px", textDecoration: "underline" }}
                    >
                      {item}
                    </span>
                    {index < row.references.length - 1 && ", "}
                  </span>
                ))
              : row.references ?? ""}
          </td>
        )}
      </>
    ) : (
      <>
        {columns.map((col, cIdx) => {
                      const isEditing =
                        editing &&
                        editing.rowIdx === rIdx &&
                        editing.field === col.field;
                      const inputAlignClass =
                        col.field === "notes"
                          ? "ft-input-center"
                          : col.align === "right"
                          ? "ft-input-right"
                          : col.align === "center"
                          ? "ft-input-center"
                          : "ft-input-left";

                      const cellText = displayValue(row, col.field, col);
                      const isEmptyPlaceholder =
                        row.isNewRow &&
                        (row[col.field] == null || row[col.field] === "");

                      const handleCellClick = () => {
                        if (col.type === "checkbox") return;
                        startEdit(rIdx, col);
                      };

                      const colWidth = col.width || (col.field === "baseCurrentYear" ? 160 : undefined);
                      const widthStyle = colWidth ? (typeof colWidth === "number" ? `${colWidth}px` : colWidth) : undefined;

                      return (
                      <td
                      key={cIdx}
                      style={{
                          position: cIdx === 0 && isSocieTable ? "sticky" : "relative",
                          left: cIdx === 0 && isSocieTable ? 0 : undefined,
                          zIndex: cIdx === 0 && isSocieTable ? 100 : undefined,
                          backgroundColor: row.level === 1 ? "#eaeeed" : (cIdx === 0 && isSocieTable ? "#fff" : undefined),
                          width: widthStyle,
                          minWidth: widthStyle,
                          maxWidth: widthStyle,
                        }}
                        className={`${
                          col.align === "right"
                            ? "ft-align-right"
                            : col.align === "center"
                            ? "ft-align-center"
                            : "ft-align-left"
                        } ${isEditing ? "ft-editing" : ""}`}
                          onClick={handleCellClick}
                          onDoubleClick={handleCellClick}
                        >
                          {col.type === "popup" && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent:
                                  col.align === "right"
                                    ? "flex-end"
                                    : col.align === "center"
                                    ? "center"
                                    : "flex-start",
                                textAlign:
                                  col.align === "right"
                                    ? "right"
                                    : col.align === "center"
                                    ? "center"
                                    : "left",
                                width: "100%",
                              }}
                            >
                              <span
                                className={commoncss.clickable}
                                onClick={() => {
                                  handleChecklistModal(row);
                                }}
                              >
                                {row[col.field]}
                              </span>
                            </div>
                          )}
                          {col.type === "checklistref" && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent:
                                  col.align === "right"
                                    ? "flex-end"
                                    : col.align === "center"
                                    ? "center"
                                    : "flex-start",
                                textAlign:
                                  col.align === "right"
                                    ? "right"
                                    : col.align === "center"
                                    ? "center"
                                    : "left",
                                width: "100%",
                              }}
                            >
                              {Array.isArray(row[col.field])
                                ? row[col.field].map((item, index) => (
                                    <span key={index}>
                                      <span
                                        onClick={() => {
                                          handleReferenceModal(item);
                                        }}
                                        style={{
                                          cursor: "pointer",
                                          marginRight: "8px",
                                          textDecoration: "underline",
                                        }}
                                      >
                                        {item}
                                      </span>
                                      {index < row[col.field].length - 1 && ", "}
                                    </span>
                                  ))
                                : row[col.field] ?? ""}
                            </div>
                          )}
                          {col.type === "redirect" && (
                            <div
                              style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent:
                                col.align === "right"
                                  ? "flex-end"
                                  : col.align === "center"
                                  ? "center"
                                  : "flex-start",
                              textAlign:
                                col.align === "right"
                                  ? "right"
                                  : col.align === "center"
                                  ? "center"
                                  : "left",
                              width: "100%",
                            }}
                            >
                              {row[col.field] ? (
                                <span
                                  style={{
                                    color: "#205a46",
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                    fontWeight: 600,
                                  }}
                                  onClick={() => {
                                    redirectTo(row[col.field], row);
                                  }}
                                >
                                  {row[col.field]}
                                </span>
                              ) : (
                                <span style={{ color: "#ccc" }}>{row.level === 1 ? "" : "–"}</span>
                              )}
                            </div>
                          )}
                          {col.type === "checkbox" ? (
                            <div
                              style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent:
                                col.align === "right"
                                  ? "flex-end"
                                  : col.align === "center"
                                  ? "center"
                                  : "flex-start",
                              textAlign:
                                col.align === "right"
                                  ? "right"
                                  : col.align === "center"
                                  ? "center"
                                  : "left",
                              width: "100%",
                            }}
                            >
                              <input
                                name={`chk_${rowKey}_${col.field}_${col.optionValue}`}
                                className="ft-checkbox"
                                type="checkbox"
                                checked={row[col.field] === col.optionValue}
                                onChange={(e) => {
                                  const checked = e.target.checked;
                                  toggleSingleValueCheckbox(rIdx, col, checked);
                                }}
                                onClick={(e) => e.stopPropagation()}
                                aria-label={`${col.label} checkbox row ${rIdx}`}
                              />
                            </div>
                          ) : (
                            <>
                              {col.type !== "redirect" &&
                                col.type !== "popup" &&
                                col.type !== "checklistref" && (
                                  (() => {
                                    const isCyPy = isCyPyColumn(col.field) && (activeCat === "cashflow" || (activeCat === "disclosure" && !isPrePopulate));
                                    return isCyPy ? (
                                      <div
                                        style={{
                                          visibility: isEditing ? "hidden" : "visible",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "flex-end",
                                          textAlign: "right",
                                          width: "100%",
                                        }}
                                      >
                                        <span
                                          style={{
                                            flex: 1,
                                            textAlign: "right",
                                            color: isEmptyPlaceholder ? "#aaa" : col.field === "notes" ? "#205a46" : "inherit",
                                            fontStyle: isEmptyPlaceholder ? "normal" : "normal",
                                            fontWeight: (col.field === "notes" || isRowBold(row)) ? 700 : "inherit",
                                            textDecoration: col.field === "notes" && !isEmptyPlaceholder ? "underline" : "none",
                                          }}
                                        >
                                          {cellText}
                                        </span>
                                        <div
                                          style={{
                                            width: "26px !important",
                                            minWidth: "26px",
                                            height: "22px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            flexShrink: 0,
                                            marginLeft: "4px",
                                          }}
                                        >
                                          {renderCellLinkIcon(row, col.field, rIdx)}
                                        </div>
                                      </div>
                                    ) : (
                                      <div
                                        style={{
                                          visibility: isEditing ? "hidden" : "visible",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: col.align === "right" ? "flex-end" : col.align === "center" ? "center" : "flex-start",
                                          textAlign: col.align || "left",
                                          width: "100%",
                                          gap: "6px",
                                        }}
                                      >
                                        <span
                                          style={{
                                            color: isEmptyPlaceholder ? "#aaa" : col.field === "notes" ? "#205a46" : "inherit",
                                            fontStyle: isEmptyPlaceholder ? "normal" : "normal",
                                            fontWeight: (col.field === "notes" || isRowBold(row)) ? 700 : "inherit",
                                            textDecoration: col.field === "notes" && !isEmptyPlaceholder ? "underline" : "none",
                                          }}
                                        >
                                          {cellText}
                                        </span>
                                        {renderCellLinkIcon(row, col.field, rIdx)}
                                      </div>
                                    );
                                  })()
                                )}

                              {isEditing &&
                                col.type !== "redirect" &&
                                col.type !== "popup" &&
                                col.type !== "checklistref" && (
                                  <input
                                    ref={inputRef}
                                    className={`ft-edit-input ${inputAlignClass} ${(cIdx === columns.length - 1 && (allowDragAndAdd || activeCat === "cashflow")) ? "ft-edit-input-last-cell" : ""}`}
                                    type={
                                      col.type === "number" ? "number" : "text"
                                    }
                                    defaultValue={
                                      col.type === "array" &&
                                      Array.isArray(row[col.field])
                                        ? row[col.field].join(", ")
                                        : row[col.field] ?? ""
                                    }
                                    placeholder={
                                      row.isNewRow
                                        ? isValueColumn(col)
                                          ? "0"
                                          : "Enter text"
                                        : col.placeholder ?? ""
                                    }
                                    onBlur={(e) => commitValue(e.target.value)}
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter")
                                        commitValue(e.target.value);
                                      if (e.key === "Escape") cancel();
                                    }}
                                    onKeyUp={(e) => {
                                      const raw = e.target.value;
                                      let outgoing = raw;
                                      if (col.type === "number") {
                                        const n =
                                          raw === "" ? null : Number(raw);
                                        outgoing = isNaN(n) ? null : n;
                                      } else if (col.type === "array") {
                                        outgoing = String(raw)
                                          .split(",")
                                          .map((v) => v.trim())
                                          .filter(Boolean);
                                      }
                                      const updated = [...localRows];
                                      updated[rIdx] = {
                                        ...updated[rIdx],
                                        [col.field]: outgoing,
                                      };
                                      setLocalRows(updated);
                                      emitImmediateChange(
                                        rIdx,
                                        col.field,
                                        outgoing
                                      );
                                    }}
                                  />
                                )}
                            </>
                          )}

                          {/* Action icons - last cell only */}
                          {cIdx === columns.length - 1 && (allowDragAndAdd || activeCat === "cashflow") && (
                            <>
                              <div
                                className={`ft-row-bold-icon ${isRowBold(row) ? "active" : ""}`}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleToggleBold(rIdx);
                                }}
                                title={isRowBold(row) ? "Remove Bold" : "Make Bold"}
                              >
                                <img src={BoldIcon} alt="Bold" style={{ width: 14, height: 14 }} />
                              </div>

                              {row.lineType !== "header" && (
                                <div
                                  className="ft-row-delete-icon"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDeleteCashflowRow(rIdx);
                                  }}
                                  title="Delete row"
                                >
                                  <DelIcon style={{ width: 16, height: 16 }} />
                                </div>
                              )}
                            </>
                          )}
                        </td>
                      );
                    })}
                    </>
                  )}
                </tr>
                        );
                      })
              )}
          </tbody>
          )}
          {allowDragAndAdd && activeCat !== "cashflow" && (
            <tfoot>
              <tr>
                <td colSpan={columns.length} style={{ border: "none", padding: "8px 0" }}>
                  <button
                    type="button"
                    onClick={addNewRow}
                    style={{
                      background: "none",
                      border: "none",
                      color: "#205a46",
                      cursor: "pointer",
                      fontWeight: "500",
                      padding: "8px 12px 8px 0px",
                      fontSize: "14px",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <PlusIcon style={{ width: 14, height: 14, marginTop: "-2px" }} /> Add Line Item
                  </button>
                </td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>
      <DeletePopup
        isOpen={deleteConfirmData}
        title={tableType === "link register" ? <>Confirm deletion of <span style={{ fontWeight: 700 }}>linked register data</span>?</> : "Confirm Deletion"}
        message="Once deleted, you will not be able to recover this!"
        onConfirm={async () => {
          setDeleteConfirmData(false);
          await deletePopulateFS(tableId);
        }}
        onCancel={() => setDeleteConfirmData(false)}
      />
      {showChecklistModal && modalData && (
        <ChecklistModal
          setShowChecklistModal={setShowChecklistModal}
          modalData={modalData}
        />
      )}
      {viewReferenceModal && refrenceModalData && (
        <ReferenceModal
          setViewReferenceModal={setViewReferenceModal}
          modalData={refrenceModalData}
        />
      )}
    </div>
  );
}